import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaMinusSquare, FaPlusSquare } from "react-icons/fa";
import { IoMdLock } from "react-icons/io";
import { FiDownload } from "react-icons/fi";
import { IoDocumentTextOutline } from "react-icons/io5"; // Assuming the download icon is from react-icons
import styles from "../commanstyles.module.css";

function ContributionByPartnerSummaryTable({ isSubScribe, data }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [isTableOneOpen, setIsTableOneOpen] = useState(true);
  const [selectedYearPartnerContribution, setSelectedPartnerContribution] = useState("");
  const rowsPerPage = 10;

  const toggleTableOne = () => {
    if (!isSubScribe) {
      alert("Please unlock to see the data.");
      return;
    }
    setIsTableOneOpen((prev) => !prev);
  };

  useEffect(() => {
    const years = getAvailableYears();
    if (years.length > 0) {
      setSelectedPartnerContribution(years[0]); // Set the latest year as default
    }
  }, [data]);

  const getAvailableYears = () => {
    const years = Array.from(
      new Set(data.map((item) => item.financial_year))
    ).sort((a, b) => b - a); // Sort years in descending order
    return years;
  };

  const filteredData = data.filter((item) =>
    selectedYearPartnerContribution
      ? item.financial_year == selectedYearPartnerContribution
      : true
  );

  const totalPages = Math.ceil(filteredData.length / rowsPerPage); // Calculate pages based on filtered data

  const handleClick = (page) => {
    setCurrentPage(page);
  };

  const handlePrevious = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  return (
    <div className={styles.table_subcontainer}>
      {!isSubScribe && (
        <button className={styles.Subscription_msg} onClick={() => navigate("/kohere/mycredits", { state: { active: "BuyCredits" } })}>
          <IoMdLock /> Subscription required to view data
        </button>
      )}

      {isSubScribe && (
        <div className={styles.highlet_header_content1}>
          <p className={styles.minuse_icon} onClick={toggleTableOne}>
            {isTableOneOpen ? (
              <FaMinusSquare size={22} />
            ) : (
              <FaPlusSquare size={22} />
            )}
          </p>
          <h3 className={styles.highlet_text}>
            {/* CONTRIBUTION BY PARTNER - 31 Mar, {selectedYearPartnerContribution || "All Years"} */}
            CONTRIBUTION BY PARTNER
            {filteredData.length > 0 &&
              selectedYearPartnerContribution &&
              ` - 31 Mar, ${selectedYearPartnerContribution}`}
          </h3>
          {/* Financial Year Dropdown */}
          {filteredData.length > 0 && (
            <div className={styles.yearSelectContainer}>
              <select
                value={selectedYearPartnerContribution}
                onChange={(e) => setSelectedPartnerContribution(e.target.value)}
              >
                <option value="">All Years</option>
                {getAvailableYears().map((year) => (
                  <option key={year} value={year}>
                    {parseInt(year) - 1} - {year}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>
      )}

      {isTableOneOpen && isSubScribe && (
        <>
          {/* Reference Documents Section */}
          <span>
            <div>
              {filteredData.length > 0 && [filteredData[0]].map((item) => (
                <div key={item.Id} className={styles.referencedoc_main}>
                  <div>
                    <b>Reference Documents</b>
                  </div>

                  <div className={styles.referencedoc_container}>
                    {item.refDoc ? (
                      <>
                        <div>
                          {item.refDoc?.MaiinFileName && (
                            <a
                              href={item.refDoc?.fileurl}
                              target="_blank"
                              rel="noopener noreferrer"
                              className={styles.referencedoc_mainfilename}
                              style={{ color: "#083A7F", display: "inline-block", marginBottom: "10px", cursor: "pointer" }}
                            >
                              {item.refDoc?.MaiinFileName}
                            </a>
                          )}
                          <ul style={{ padding: 0, margin: 0, listStyle: "none" }}>
                            {item.refDoc?.Attachments &&
                              item.refDoc?.Attachments.length > 0 ? (
                              item.refDoc?.Attachments.map(
                                (attachment, index) => (
                                  <li
                                    key={index}
                                    className={styles.referencedoc_Attachments}
                                    style={{ marginBottom: "8px", cursor: "pointer" }}
                                  >
                                    <IoDocumentTextOutline
                                      size={16}
                                      style={{
                                        marginRight: "8px",
                                        color: "#2961EF",
                                        flexShrink: 0,
                                        cursor: "pointer",
                                      }}
                                    />
                                    <a
                                      href={attachment.fileurl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        textDecoration: "none",
                                        color: "#2961EF",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {attachment.Name}
                                    </a>
                                    <button
                                      onClick={() => {
                                        const link =
                                          document.createElement("a");
                                        link.href = attachment.fileurl;
                                        link.download = attachment.Name;
                                        link.click();
                                      }}
                                      title="Download"
                                      style={{
                                        background: "none",
                                        border: "none",
                                        cursor: "pointer",
                                        color: "#F5B301",
                                        marginLeft: "10px",
                                        textDecoration: "underline",
                                      }}
                                    >
                                      <FiDownload />
                                    </button>
                                  </li>
                                )
                              )
                            ) : (
                              <span>No attachments available.</span>
                            )}
                          </ul>
                        </div>
                      </>
                    ) : (
                      <span>No documents available for selected year</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </span>

          {/* Table displaying the filtered data */}
          <table className={styles.commantable}>
            <thead>
              <tr className={styles.tableHeaderRow}>
                <th className={styles.tableHeader}>SNo.</th>
                <th className={styles.tableHeader}>Name</th>
                <th className={styles.tableHeader}>DIN</th>
                <th className={styles.tableHeader}>Designation</th>
                <th className={styles.tableHeader}>
                  Obligation of Contribution (INR)
                </th>
                <th className={styles.tableHeader}>
                  Contribution Received (INR)
                </th>
              </tr>
            </thead>
            <tbody>
              {currentData.length > 0 ? (
                currentData.map((row, index) => (
                  <tr key={row.Id} className={styles.tableRow}>
                    <td className={styles.tableCell}>
                      {indexOfFirstRow + index + 1}.
                    </td>
                    <td className={styles.tableCell}>{row.name}</td>
                    <td className={styles.tableCell}>{row.DIN}</td>
                    <td className={styles.tableCell}>{row.designation}</td>
                    <td className={styles.tableCell}>
                      {row.obligation_of_contribution}
                    </td>
                    <td className={styles.tableCell}>
                      {row.contribution_received}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className={styles.noDataRow}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* Pagination */}
          <div className={styles.pagination}>
            <button onClick={handlePrevious} disabled={currentPage === 1}>
              &lt;
            </button>
            {[...Array(totalPages).keys()].map((num) => (
              <button
                key={num + 1}
                onClick={() => handleClick(num + 1)}
                className={currentPage === num + 1 ? styles.active : ""}
              >
                {num + 1}
              </button>
            ))}
            <button onClick={handleNext} disabled={currentPage === totalPages}>
              &gt;
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default ContributionByPartnerSummaryTable;
